import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-662ec80e.js';
import { w as waitNextRender, r as resolveNextRender } from './browser-202fc7f4.js';
import { r as runValidation } from './form-4ba95191.js';
import { c as currentLocale } from './i18n-939e2dee.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { b as vMinLength, a as vString, W as vArrayOf, J as vNumber, Q as vBoolean, a1 as vUndefOr, a2 as vFunction } from './validation-02b8d01d.js';

const dsSelectCss = "ds-select:not([is-without-styling]),ds-select-multiple:not([is-without-styling]){display:block;position:relative;height:fit-content}ds-select:not([is-without-styling]):not([is-float-label]) label,ds-select-multiple:not([is-without-styling]):not([is-float-label]) label{color:var(--coolGrey-700) !important;font-weight:500}ds-select:not([is-without-styling])>input,ds-select-multiple:not([is-without-styling])>input{position:absolute;z-index:-1;outline:none;border:1px transparent;font-size:0.88888889rem;line-height:1.56rem;width:100%;box-shadow:none}ds-select:not([is-without-styling])>input+label,ds-select-multiple:not([is-without-styling])>input+label{z-index:2;position:absolute;left:0;top:0;background-color:white;transform-origin:top left;transform:translateY(13px) translateX(12px);color:#909ba8;transition:transform 0.2s ease-in-out;padding:0 calc(var(--gw) * 0.5);line-height:1.25;border-radius:var(--radius);pointer-events:none;font-size:0.88888889rem;line-height:1.56rem}ds-select:not([is-without-styling])>input:focus+label,ds-select-multiple:not([is-without-styling])>input:focus+label{color:var(--primary);transform:translateY(-9px) translateX(12px) scale(0.8)}ds-select:not([is-without-styling])[is-float-label][has-value] label,ds-select-multiple:not([is-without-styling])[is-float-label][has-value] label,ds-select:not([is-without-styling])[is-float-label][is-open] label,ds-select-multiple:not([is-without-styling])[is-float-label][is-open] label{transform:translateY(-9px) translateX(12px) scale(0.8) !important}ds-select:not([is-without-styling])>label,ds-select-multiple:not([is-without-styling])>label{display:block;margin-bottom:0.25rem !important;color:#909ba8;font-size:0.88888889rem;line-height:1.56rem}ds-select:not([is-without-styling]) .options-container,ds-select-multiple:not([is-without-styling]) .options-container{visibility:hidden;opacity:0;position:absolute;width:100%;z-index:10;border:1px solid var(--grey-600);border-radius:var(--radius);background-color:var(--white);transition:visibility 0s 0.25s, opacity 0.25s linear}ds-select:not([is-without-styling])[is-scrollable] .options-container,ds-select-multiple:not([is-without-styling])[is-scrollable] .options-container{overflow-y:auto;max-height:13rem}ds-select:not([is-without-styling]) ds-icon.clear,ds-select-multiple:not([is-without-styling]) ds-icon.clear{position:absolute;right:1.8rem;bottom:0.35rem;padding:0.7rem !important;cursor:pointer;visibility:hidden;background:white;z-index:1}ds-select:not([is-without-styling]) ds-icon.toggle,ds-select-multiple:not([is-without-styling]) ds-icon.toggle{position:absolute;right:0;padding:0.9rem;z-index:1;cursor:pointer;pointer-events:none;transition:transform 0.25s ease;visibility:visible}ds-select:not([is-without-styling])[has-value][is-clearable] ds-icon.clear,ds-select-multiple:not([is-without-styling])[has-value][is-clearable] ds-icon.clear{visibility:visible}ds-select:not([is-without-styling])[has-value][is-clearable]:not([is-searchable]) .value-container,ds-select-multiple:not([is-without-styling])[has-value][is-clearable]:not([is-searchable]) .value-container{width:calc(100% - 5.3rem);padding-right:4rem}ds-select:not([is-without-styling])[has-value][is-clearable][is-searchable] .value-container,ds-select-multiple:not([is-without-styling])[has-value][is-clearable][is-searchable] .value-container{width:calc(100% - 5rem)}ds-select:not([is-without-styling]) .help-error,ds-select-multiple:not([is-without-styling]) .help-error{margin:0.45rem 1.25rem 0;line-height:1;color:var(--red-500) !important;font-size:0.79012346rem;line-height:1.3rem;display:none}ds-select:not([is-without-styling])[is-open] .options-container,ds-select-multiple:not([is-without-styling])[is-open] .options-container{visibility:visible;opacity:1;transition:visibility 0s, opacity 0s linear}ds-select:not([is-without-styling])[is-open][is-searchable] .value-container,ds-select-multiple:not([is-without-styling])[is-open][is-searchable] .value-container{display:none}ds-select:not([is-without-styling])[is-open]:not([is-searchable]) .value-container,ds-select-multiple:not([is-without-styling])[is-open]:not([is-searchable]) .value-container{border-color:var(--primary)}ds-select:not([is-without-styling])[is-open]:not([is-searchable]) label,ds-select-multiple:not([is-without-styling])[is-open]:not([is-searchable]) label{color:var(--primary)}ds-select:not([is-without-styling])[is-open] ds-icon.toggle,ds-select-multiple:not([is-without-styling])[is-open] ds-icon.toggle{transform-origin:center;transform:rotate(180deg)}ds-select:not([is-without-styling])[is-readonly] ds-icon.toggle,ds-select-multiple:not([is-without-styling])[is-readonly] ds-icon.toggle{display:none}ds-select:not([is-without-styling])[is-searchable] .value-container,ds-select-multiple:not([is-without-styling])[is-searchable] .value-container{display:block;position:absolute;pointer-events:none;z-index:1;width:calc(100% - var(--gw) * 3.95);margin-right:calc(var(--gw) * 2.75);margin-left:calc(var(--gw) * 1.2);margin-top:calc(var(--gw) / 1.51);margin-bottom:calc(var(--gw) / 1.5);background-color:white;font-size:0.88888889rem;line-height:1.56rem}ds-select:not([is-without-styling])[is-searchable] .value-container [slot='value']>*,ds-select-multiple:not([is-without-styling])[is-searchable] .value-container [slot='value']>*{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%}ds-select:not([is-without-styling])[is-searchable] ds-input-string,ds-select-multiple:not([is-without-styling])[is-searchable] ds-input-string{z-index:0}ds-select:not([is-without-styling])[is-searchable] ds-input-string input,ds-select-multiple:not([is-without-styling])[is-searchable] ds-input-string input{width:100%;box-sizing:border-box}ds-select:not([is-without-styling])[is-searchable] ds-input-string .help-info,ds-select-multiple:not([is-without-styling])[is-searchable] ds-input-string .help-info{display:none}ds-select:not([is-without-styling])[is-searchable]>label,ds-select-multiple:not([is-without-styling])[is-searchable]>label{display:block}ds-select:not([is-without-styling])[is-searchable] ds-input-string label,ds-select-multiple:not([is-without-styling])[is-searchable] ds-input-string label{display:none}ds-select:not([is-without-styling]):not([is-searchable]),ds-select-multiple:not([is-without-styling]):not([is-searchable]){cursor:pointer}ds-select:not([is-without-styling]):not([is-searchable]) ds-input-string,ds-select-multiple:not([is-without-styling]):not([is-searchable]) ds-input-string{display:none}ds-select:not([is-without-styling]):not([is-searchable]) .value-container,ds-select-multiple:not([is-without-styling]):not([is-searchable]) .value-container{z-index:0;position:relative;min-width:3.5rem;box-sizing:content-box;display:block;background-color:white;font-size:0.88888889rem;line-height:1.56rem;border-width:1px;border-style:solid;border-radius:var(--radius);border-color:var(--grey-600);padding-right:calc(var(--gw) * 2);padding-left:calc(var(--gw) * 1.2);padding-top:calc(var(--gw) / 1.5);padding-bottom:calc(var(--gw) / 1.5)}ds-select:not([is-without-styling]):not([is-searchable]) .value-container [slot='value']>*,ds-select-multiple:not([is-without-styling]):not([is-searchable]) .value-container [slot='value']>*{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%}ds-select:not([is-without-styling]):not([is-searchable]) .value-container [slot='value']>*::after,ds-select-multiple:not([is-without-styling]):not([is-searchable]) .value-container [slot='value']>*::after{content:'\\00a0'}ds-select:not([is-without-styling]):not([is-searchable]) label,ds-select-multiple:not([is-without-styling]):not([is-searchable]) label{display:block;color:#909ba8;font-size:0.88888889rem;line-height:1.56rem}ds-select:not([is-without-styling]).error .value-container,ds-select-multiple:not([is-without-styling]).error .value-container{border-color:var(--red-500) !important}ds-select:not([is-without-styling]).error label,ds-select-multiple:not([is-without-styling]).error label{color:var(--red-500) !important}ds-select:not([is-without-styling]).error .help-error,ds-select-multiple:not([is-without-styling]).error .help-error{display:block}ds-select:not([is-without-styling])[is-loading] ds-select-option,ds-select-multiple:not([is-without-styling])[is-loading] ds-select-option{display:none}ds-select:not([is-without-styling])[is-loading] ds-select-option.loading,ds-select-multiple:not([is-without-styling])[is-loading] ds-select-option.loading{display:block}ds-select:not([is-without-styling]):not([is-loading]) ds-select-option.loading,ds-select-multiple:not([is-without-styling]):not([is-loading]) ds-select-option.loading{display:none}ds-select:not([is-without-styling])[is-mini] .value-container,ds-select-multiple:not([is-without-styling])[is-mini] .value-container{line-height:1 !important;font-size:0.79012346rem;line-height:1.3rem}ds-select:not([is-without-styling])[is-mini]:not([is-searchable]) .value-container,ds-select-multiple:not([is-without-styling])[is-mini]:not([is-searchable]) .value-container{margin:0}ds-select:not([is-without-styling])[is-mini] label,ds-select-multiple:not([is-without-styling])[is-mini] label{font-size:0.79012346rem;line-height:1.3rem;line-height:1}ds-select:not([is-without-styling])[is-mini] ds-icon,ds-select-multiple:not([is-without-styling])[is-mini] ds-icon{padding:0.5rem !important}ds-select:not([is-without-styling])[is-mini] ds-icon.clear,ds-select-multiple:not([is-without-styling])[is-mini] ds-icon.clear{padding:0.2rem 0.4rem !important;bottom:0.15rem;margin:0.3rem 0 !important}ds-select:not([is-without-styling])[is-mini][is-float-label] label,ds-select-multiple:not([is-without-styling])[is-mini][is-float-label] label{line-height:1.5 !important;margin:0;padding:0;transform-origin:top left;transform:translateY(10px) translateX(6px);background-color:white;color:var(--coolGrey-400);padding:0 calc(var(--gw) * 0.5)}ds-select:not([is-without-styling])[is-mini][is-float-label][has-value] label,ds-select-multiple:not([is-without-styling])[is-mini][is-float-label][has-value] label,ds-select:not([is-without-styling])[is-mini][is-float-label][is-searchable][is-open] label,ds-select-multiple:not([is-without-styling])[is-mini][is-float-label][is-searchable][is-open] label{transform:translateX(10px) translateY(-9px) scale(0.9) !important}";

const DsSelectMultiple = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dsInput = createEvent(this, "dsInput", 7);
    this.search = createEvent(this, "search", 7);
    this.nextRenderPromises = [];
    this.propError = {};
    this.currentLocale = currentLocale();
    this.name = undefined;
    this.label = '';
    this.value = [];
    this.isLoading = false;
    this.isDisabled = false;
    this.isReadonly = false;
    this.isMini = false;
    this.isFloatLabel = false;
    this.isWithoutStyling = false;
    this.isSearchable = false;
    this.isClearable = false;
    this.isScrollable = true;
    this.validate = undefined;
    this.displayError = false;
    this.validationError = undefined;
    this.injectedError = undefined;
    this.isOpen = false;
    this.cursorPosition = -1;
  }
  // istanbul ignore next
  updateLocale() {
    this.currentLocale = currentLocale();
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vMinLength(1)))
      return;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vString))
      return;
  }
  watchValue() {
    /* istanbul ignore if */
    if (!propCheck(this, 'value', 'Array<string | number>', vArrayOf(v => vString(v) && vNumber(v))))
      return;
    this.injectedError = undefined;
    runValidation(this);
    Array.from(this.hostElement.querySelectorAll('ds-select-option')).map(option => {
      if (option.isDisabled)
        return;
      const isSelected = this.value.includes(option.value);
      option.isSelected = isSelected;
    });
  }
  watchIsLoading() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isLoading', 'boolean', vBoolean))
      return;
  }
  async watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
    if (this.isDisabled)
      this.dsInput.emit([]);
    await waitNextRender(this);
    runValidation(this);
  }
  async watchIsReadonly() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isReadonly', 'boolean', vBoolean))
      return;
    await waitNextRender(this);
    runValidation(this);
  }
  watchIsMini() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isMini', 'boolean', vBoolean))
      return;
  }
  watchIsFloatLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isFloatLabel', 'boolean', vBoolean))
      return;
  }
  watchIsWithoutStyling() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isWithoutStyling', 'boolean', vBoolean))
      return;
  }
  watchIsSearchable() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isSearchable', 'boolean', vBoolean))
      return;
  }
  watchIsClearable() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isClearable', 'boolean', vBoolean))
      return;
  }
  watchIsScrollable() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isScrollable', 'boolean', vBoolean))
      return;
  }
  watchValidate() {
    /* istanbul ignore if */
    if (!propCheck(this, 'validate', '(value: any) => string | undefined', vUndefOr(vFunction)))
      return;
    runValidation(this);
  }
  async injectError(error) {
    this.injectedError = error;
    runValidation(this);
    this.displayError = true;
  }
  async hideError() {
    this.injectedError = undefined;
    runValidation(this);
    this.displayError = false;
  }
  async open() {
    clearTimeout(this.closeTimeout);
    if (this.isOpen || this.isReadonly)
      return;
    this.isOpen = true;
    this.cursorPosition = -1;
    if (this.isSearchable)
      this.searchElement.querySelector('input').focus({ preventScroll: true });
    else
      this.inputElement.focus({ preventScroll: true });
    await waitNextRender(this);
    this.optionsElement.scrollTop = 0;
  }
  async close() {
    clearTimeout(this.closeTimeout);
    const closeAction = () => {
      if (!this.isOpen)
        return;
      this.isOpen = false;
      this.displayError = true;
      if (this.isSearchable)
        this.searchElement.querySelector('input').blur();
      else
        this.inputElement.blur();
    };
    this.closeTimeout = setTimeout(closeAction, 64);
  }
  matchCurrentOrClosest(el, selector) {
    if (el.matches(selector))
      return el;
    else
      return el.closest(selector);
  }
  checkForClickOutside(e) {
    if (this.hostElement.contains(e.target))
      return;
    this.close();
  }
  handleClick(e) {
    const target = e.target;
    const option = this.matchCurrentOrClosest(target, 'ds-select-option');
    if (option) {
      if (option.isDisabled)
        return;
      this.selectOption(option);
    }
    else
      this.isOpen ? this.close() : this.open();
  }
  handleKeyDown(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      e.stopPropagation();
      const selectOptions = this.hostElement.querySelectorAll('ds-select-option:not([is-disabled])');
      if (this.cursorPosition >= 0)
        selectOptions[this.cursorPosition].isCursorActive = false;
      if (e.key === 'ArrowUp' && this.cursorPosition > 0)
        this.cursorPosition--;
      else if (e.key === 'ArrowDown' && this.cursorPosition < selectOptions.length - 1)
        this.cursorPosition++;
      /* istanbul ignore else */
      if (this.cursorPosition >= 0) {
        const selectedOption = selectOptions[this.cursorPosition];
        selectedOption.isCursorActive = true;
        /* istanbul ignore else */
        if (this.isScrollable)
          selectedOption.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      }
    }
    else if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const selectOptions = this.hostElement.querySelectorAll('ds-select-option:not([is-disabled])');
      /* istanbul ignore else */
      if (this.cursorPosition >= 0) {
        const selectedOption = selectOptions[this.cursorPosition];
        /* istanbul ignore else */
        if (selectedOption)
          this.selectOption(selectedOption);
      }
    }
  }
  selectOption(option) {
    if (this.isReadonly)
      return;
    if (!option) {
      this.dsInput.emit([]);
    }
    else if (this.value.includes(option.value)) {
      const idx = this.value.findIndex(v => v === option.value);
      const newValue = [...this.value];
      newValue.splice(idx, 1);
      this.dsInput.emit(newValue);
    }
    else {
      this.dsInput.emit([...this.value, option.value]);
    }
  }
  searchEmit(search) {
    clearTimeout(this.searchTimeout);
    if (this.isDisabled)
      return; // do not emit on disable
    this.searchTimeout = setTimeout(() => {
      this.search.emit(search);
    }, 250);
  }
  connectedCallback() {
    runWatchers(this);
    this.updateLocale();
  }
  componentDidLoad() {
    if (this.inputElement)
      this.dsForm = this.inputElement.closest('ds-form');
    runValidation(this);
  }
  componentDidRender() {
    resolveNextRender(this);
  }
  disconnectedCallback() {
    if (this.dsForm)
      this.dsForm.checkValidity();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    const labelEl = h("label", null, this.label);
    const error = this.displayError && (this.injectedError || this.validationError);
    return (h(Host, { class: { error: !!error }, "is-open": this.isOpen, "has-value": this.value.length > 0, onClick: e => this.handleClick(e) }, !this.isFloatLabel && labelEl, h("input", { ref: el => this.inputElement = el, type: "text", disabled: this.isDisabled, readonly: this.isReadonly, onInvalid: () => { this.displayError = true; }, onKeyDown: e => this.handleKeyDown(e), tabindex: this.isSearchable ? -1 : 0 }), this.isFloatLabel && labelEl, h("ds-icon", { name: "bin", color: "var(--grey-800)", class: "clear", size: "1rem", onClick: () => {
        this.selectOption();
        if (this.isSearchable)
          this.searchElement.querySelector('input').focus({ preventScroll: true });
        else
          this.inputElement.focus({ preventScroll: true });
      } }), h("ds-icon", { name: "down-open", class: "toggle", size: "1rem", color: "var(--grey-700)" }), h("div", { class: "value-container" }, h("slot", { name: "value" })), h("ds-input-string", { class: { error: !!error }, type: "text", label: this.label, name: `${this.name}-search`, ref: el => this.searchElement = el, onDsInput: e => {
        e.stopPropagation();
        e.preventDefault();
        this.searchEmit(e.detail || '');
      }, isDisabled: this.isDisabled, isWithoutStyling: this.isWithoutStyling, isMini: this.isMini, onKeyDown: e => this.handleKeyDown(e) }), h("div", { class: "options-container", tabindex: "-1", ref: el => this.optionsElement = el, onFocus: () => this.open() }, h("ds-select-option", { class: "loading", isDisabled: true }, "Loading..."), h("slot", { name: "options" })), h("div", { class: "help-error" }, error)));
  }
  get hostElement() { return getElement(this); }
  static get watchers() { return {
    "name": ["watchName"],
    "label": ["watchLabel"],
    "value": ["watchValue"],
    "isLoading": ["watchIsLoading"],
    "isDisabled": ["watchIsDisabled"],
    "isReadonly": ["watchIsReadonly"],
    "isMini": ["watchIsMini"],
    "isFloatLabel": ["watchIsFloatLabel"],
    "isWithoutStyling": ["watchIsWithoutStyling"],
    "isSearchable": ["watchIsSearchable"],
    "isClearable": ["watchIsClearable"],
    "isScrollable": ["watchIsScrollable"],
    "validate": ["watchValidate"]
  }; }
};
DsSelectMultiple.style = dsSelectCss;

export { DsSelectMultiple as ds_select_multiple };
